import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { SetupPayStepPanelComponent } from "./setup-pay-step-panel.component";
import { SharedModule } from "src/app/shared.module";
import { DynamicFormsModule } from "src/app/_modules/modules/dynamic-forms.module";

@NgModule({
  declarations: [SetupPayStepPanelComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SharedModule,
    DynamicFormsModule
  ],
  exports: [SetupPayStepPanelComponent]
})
export class SetupPayStepPanelModule {}
